import script from "./GoogleReviewPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleReviewPrompt.vue?vue&type=script&setup=true&lang=js"

import "./GoogleReviewPrompt.vue?vue&type=style&index=0&id=c46ea9da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c46ea9da"]])

export default __exports__